import { ColumnConditionValue } from '@makyoapp/makyo-common'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useCompTableData } from '@/hooks/__project__/useCompTableData'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompChartPieWrapperCore } from '../core/charts/pie-chart/wrapper'
import { CompChartPie } from './CompChartPie'

/**
 * CompChartPieWrapper
 *
 * @todo add skeleton when dbTable is being loaded (just like list/cards)
 */
const CompChartPieWrapper = () => {
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // access table
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = getSafely(compContext.settings, [ComponentSettingKey.PieChartDataSource], '')
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  // access table data
  const maxItems = getSafely(compContext.settings, [ComponentSettingKey.PieChartDataItemsPerPage], 10)
  const filterSetting = compContext.settings[ComponentSettingKey.PieChartDataFilter] as ColumnConditionValue
  const sortBy = compContext.settings[ComponentSettingKey.PieChartDataSortBy] as string
  const sortType = compContext.settings[ComponentSettingKey.PieChartDataSortType] as string

  const [{ rows }] = useCompTableData({
    table: dbTable,
    componentId: compContext.component._id,
    pagination: { page: 0, perPage: maxItems },
    filterSetting,
    sortSetting: { sortType, sortBy },
  })

  if (!dbTable || !dbClient) return null

  return (
    <CompChartPieWrapperCore infos={infosProps} tableData={{ tableId, dbTable, dbClient, rows }}>
      {(props) => <CompChartPie {...props} />}
    </CompChartPieWrapperCore>
  )
}

export default CompChartPieWrapper
